import { render, staticRenderFns } from "./coderProjectViewAsAlert.vue?vue&type=template&id=47030ecc&scoped=true&"
import script from "./coderProjectViewAsAlert.vue?vue&type=script&lang=js&"
export * from "./coderProjectViewAsAlert.vue?vue&type=script&lang=js&"
import style0 from "./coderProjectViewAsAlert.vue?vue&type=style&index=0&id=47030ecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47030ecc",
  null
  
)

export default component.exports